import { useCallback, useState } from 'react';

/** True until `settle` is called once; pass `settle` to the first request's `.finally`. */
export function useFirstLoad(isNeeded = true): [boolean, () => void] {
    const [isLoading, setIsLoading] = useState(isNeeded);
    const settle = useCallback(() => setIsLoading(false), []);
    return [isLoading, settle];
}
